import { IoMdClose } from 'react-icons/io';
import { ServiceSelector } from '../Service/ServiceSelector';
import { Group, Paper, Skeleton, Title } from '@mantine/core';

interface Props {
  showServiceSelector: boolean;
  header: string | undefined;
  onClose: () => void;
  checkForServicePresence?: boolean;
  presentServicesId?: number[];
}

export const SectionHeader = ({
  header,
  onClose,
  showServiceSelector,
  checkForServicePresence = false,
  presentServicesId = [],
}: Props): JSX.Element => {
  return (
    <Paper radius="md" withBorder className="p-4">
      <Group gap="sm" className="h-fit">
        {!header ? (
          <Skeleton height={30} width="25%" radius="md" />
        ) : (
          <Title order={2}>{header}</Title>
        )}
        <div className="flex-grow" />
        {showServiceSelector && (
          <ServiceSelector
            checkForServicePresence={checkForServicePresence}
            presentServicesId={presentServicesId}
          />
        )}
        <IoMdClose
          size="28px"
          className="cursor-pointer duration-150 hover:text-red-700"
          onClick={onClose}
        />
      </Group>
    </Paper>
  );
};
